import axios from 'axios'
const baseURL = '/back-office'
export default class ApiManagerBoCutomer {
    static update(params) {
        return axios
            .post(`${baseURL}/communications/notifications/store`, params, {
                headers: { 'Content-Type': 'application/json' },
            })
            .then((res) => {
                return res.data
            })
            .catch((error) => {
                console.error('Error fetching customers:', error)
                throw error
            })
    }

    static get(id) {
        return axios
            .get(`${baseURL}/communications/notifications/` + id)
            .then((res) => {
                return res.data.NotificationPush
            })
            .catch((error) => {
                console.error('Error fetching customers:', error)
                throw error
            })
    }
}
